import { render, staticRenderFns } from "./cancellation.vue?vue&type=template&id=45057b86&scoped=true"
import script from "./cancellation.vue?vue&type=script&lang=js"
export * from "./cancellation.vue?vue&type=script&lang=js"
import style0 from "./cancellation.vue?vue&type=style&index=0&id=45057b86&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45057b86",
  null
  
)

export default component.exports